import { Link } from "gatsby";
import React, { useState } from "react";
import { BsPlayCircle } from "react-icons/bs";
import { FaYoutube } from "react-icons/fa";
import "./videos-header.scss";
import Button from "../../ui/button/Button";
import Separator from "../../ui/separator/Separator";
import VideosPopUp from "../videos-popup/videos-popup";
import { normalizeTwoWords } from "../../../shared/utils/stringUtilities";
import ShareModal from "../../molecules/ShareModal/ShareModal";
import { RiShareForwardFill } from "react-icons/ri";

const VideosHeader = ({ actualVideo }) => {
  const compClass = "o-videosHeader";
  const [showPopUp, setShowPopUp] = useState(false);
  const [showShareModal, setShowShareModal] = useState(false);
  return (
    <>
      <ShareModal
        open={showShareModal}
        onClose={() => setShowShareModal(!showShareModal)}
        gtmClass={`gtm${normalizeTwoWords(
          actualVideo.titulo
        )}Articulo${normalizeTwoWords(actualVideo.titulo)}Compartir`}
      />
      <VideosPopUp
        setShowPopUp={setShowPopUp}
        showPopUp={showPopUp}
        actualVideo={actualVideo}
      />
      <section
        className={compClass}
        style={{
          backgroundImage:
            `url(${
              actualVideo?.imagen ||
              actualVideo?.image ||
              actualVideo?.imagenHeader.file.url
            })` || "",
        }}
      >
        <div className={`${compClass}__wrapper`}>
          <div className={`${compClass}__column`}>
            <p className={`${compClass}__breadcum`}>
              {actualVideo?.migaDePan || ""}
            </p>
            <span className={`${compClass}__tag`}>Video</span>
            <h1
              className={`${compClass}__title`}
              dangerouslySetInnerHTML={{ __html: actualVideo?.titulo || "" }}
            ></h1>
            <p className={`${compClass}__excerpt`}>{actualVideo?.span || ""}</p>
            <div className={`${compClass}__actions`}>
              <Button onClick={() => setShowPopUp(true)}>
                <BsPlayCircle className={`${compClass}__buttonIcon`} />
                Ver Video
              </Button>
              <Link
                target="_blank"
                rel="noreferrer"
                className={`${compClass}__subscribe`}
                to={"https://www.youtube.com/@ComfamaCCF"}
              >
                <span style={{ marginRight: "2rem" }}>Suscríbete:</span>{" "}
                <FaYoutube />{" "}
                <span style={{ marginLeft: ".3rem" }}>YOUTUBE</span>
              </Link>
            </div>
            <Separator />
            <div
              className={`${compClass}__share`}
              onClick={() => setShowShareModal(true)}
            >
              <RiShareForwardFill />{" "}
              <span style={{ marginLeft: ".3rem" }}>Compartir</span>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default VideosHeader;
